import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7318445f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-10 col-lg-4 p-3 bg-light custom-modal m-auto rounded-3 mt-5" }
const _hoisted_2 = { class: "row pt-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Vous avez une carte VA? 🦏")
], -1))
const _hoisted_4 = { class: "col-1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, " close ", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "row m-2 pt-3" }
const _hoisted_8 = {
  key: 0,
  class: "col bg-primary text-start text-light rounded pt-3 mx-3"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Une carte VAvantages est déjà enregistrée pour ce compte. Assurez-vous que les informations renseignées soient correctes. Si ce n'est pas le cas, vous pouvez cliquer sur Modifier afin de les mettre à jour. ", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "col bg-primary text-start text-light rounded pt-3 mx-3"
}
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<p data-v-7318445f> La carte VA est une carte délivrée aux étudiants de l&#39;INSA de Lyon. Elle doit être en cours de validité et vous devez bénéficier de l&#39;<strong data-v-7318445f>adhésion VAvantages</strong> pour sa validation. Pour tout problème avec la carte VA, merci d&#39;envoyer un petit e-mail à <a href=\"mailto:overrun@24heures.org\" data-v-7318445f>overrun@24heures.org</a> en indiquant: </p><ul class=\"ms-5\" data-v-7318445f><li class=\"fw-bold\" data-v-7318445f>Votre pseudo</li><li class=\"fw-bold\" data-v-7318445f>Votre nom</li><li class=\"fw-bold\" data-v-7318445f>Votre prénom</li><li class=\"fw-bold\" data-v-7318445f>Votre numéro de carte VA</li></ul>", 2)
const _hoisted_14 = [
  _hoisted_12
]
const _hoisted_15 = { class: "row m-2 pt-3" }
const _hoisted_16 = { class: "col text-start fw-bold" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-12 my-2 my-lg-0 col-lg form-group" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputFirstName" }, "Prénom de la carte VAvantages: ", -1))
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "col-12 my-2 my-lg-0 col-lg form-group" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputLastName" }, "Nom de la carte VAvantages:", -1))
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "row mt-2" }
const _hoisted_25 = { class: "col form-group" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputVA" }, "Numéro de carte VAvantages: ", -1))
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "row mt-3" }
const _hoisted_29 = { class: "col col-lg-5 text-start" }
const _hoisted_30 = {
  key: 1,
  type: "submit",
  class: "btn btn-primary"
}
const _hoisted_31 = { class: "col text-end" }
const _hoisted_32 = {
  type: "submit",
  class: "btn btn-success"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "backdrop overflow-scroll",
    onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            id: "close-arrow",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, _hoisted_6)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.previousVaExists && !_ctx.updatePreviousVa)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("form", {
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendVa && _ctx.sendVa(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vaFirstName) = $event)),
                  type: "text",
                  class: "form-control",
                  id: "inputFirstName",
                  disabled: _ctx.previousVaExists && !_ctx.updatePreviousVa
                }, null, 8, _hoisted_20), [
                  [_vModelText, _ctx.vaFirstName]
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.vaLastName) = $event)),
                  type: "text",
                  class: "form-control",
                  id: "inputLastName",
                  disabled: _ctx.previousVaExists && !_ctx.updatePreviousVa
                }, null, 8, _hoisted_23), [
                  [_vModelText, _ctx.vaLastName]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _withDirectives(_createElementVNode("input", {
                  title: "Le numéro de la carte VAvantages est le numéro commençant par 'c' suivi de 12 chiffres. Il se trouve en-dessous du code-barres sur la carte.",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.vaNumber) = $event)),
                  type: "text",
                  class: "form-control",
                  pattern: "[c][0-9]{12}",
                  placeholder: "c000000000000",
                  id: "inputVA",
                  disabled: _ctx.previousVaExists && !_ctx.updatePreviousVa
                }, null, 8, _hoisted_27), [
                  [_vModelText, _ctx.vaNumber]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                (_ctx.previousVaExists && !_ctx.updatePreviousVa)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toogleUpdateVa && _ctx.toogleUpdateVa(...args))),
                      type: "button",
                      class: "btn btn-primary"
                    }, " Modifier "))
                  : (_openBlock(), _createElementBlock("button", _hoisted_30, " Valider "))
              ]),
              _createElementVNode("div", _hoisted_31, [
                _withDirectives(_createElementVNode("button", _hoisted_32, " Les informations sont correctes ", 512), [
                  [_vShow, _ctx.previousVaExists && !_ctx.updatePreviousVa]
                ])
              ])
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}